import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'

import { CHECK_AUTH } from "./store/actions.type";
import ApiService from "./common/api.service";
// import DateFilter from "./common/date.filter";
// import ErrorFilter from "./common/error.filter";
import Ads from 'vue-google-adsense'
import titleMixin from '@/views/mixins/titleMixin'
import VueAnalytics from 'vue-analytics'


Vue.mixin(titleMixin)

Vue.config.productionTip = false

Vue.use(require('vue-script2'))

// Analytics
Vue.use(VueAnalytics, {
  id: 'UA-31679605-1',
  router
})

Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

Vue.use(BootstrapVue)
// Vue.filter("date", DateFilter);
// Vue.filter("error", ErrorFilter);

ApiService.init();

// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
  store.dispatch(CHECK_AUTH).then((auth) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!auth) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    } else {
      next() // make sure to always call next()!
    }
  })
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
